import { useIdentity } from '@vp/auth-react';
import { useContext, useState, useCallback, useEffect } from 'react';
import { API_ENDPOINTS } from './src-config-api-config.js';
import { getChatbotToken, getRestId } from './src-utils-session-storage-utils.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { useCustomTracking } from './src-hooks-custom-hooks-useTracking.js';

const useCBChatEscalate = () => {
  const { logCustomAttributesNR } = useNRLogging();
  const { sendTrackingEvent } = useCustomTracking();
  const {
    state: { customFlow }
  } = useContext(ChatbotContext);
  const [data, setData] = useState();
  const identity = useIdentity();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [toggle, setToggle] = useState(false);
  const trigger = useCallback(() => {
    setToggle((prev) => !prev);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (toggle) {
        setLoading(true);
        try {
          const { authorizationHeader, canonicalId } = identity;
          const chatbotToken = getChatbotToken();
          const myHeaders = new Headers();
          myHeaders.append("Authorization", authorizationHeader || "");
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Chatbot-Authorization", `Bearer ${chatbotToken}`);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
              agent_name: "BOT",
              request_id: getRestId() || "",
              shopper_id: canonicalId || "",
              channel: "chat"
            }),
            redirect: "follow"
          };
          logCustomAttributesNR("ca-chatbot-api-request", {
            logLevel: "info",
            message: "Escalating chatbot session",
            apiType: "escalateChatbotSession"
          });
          if (customFlow && customFlow.flowType && customFlow.flowStep) {
            sendTrackingEvent("Chatbot Clicked", "Chatbot:OrderFlow", "chatbotFlowEscalated", "GEN AI Chatbot", {
              chatbotFlowId: customFlow.flowType,
              chatbotFlowStep: customFlow.flowStep
            });
          }
          fetch(`${API_ENDPOINTS.CHATBOT_BASE_URL()}/escalate-chat`, requestOptions).then((response) => {
            if (!response.ok) {
              const error2 = new Error(`API responded with status: ${response.status}`);
              error2.name = "ApiError";
              throw error2;
            }
            return response.json();
          }).then((result) => {
            logCustomAttributesNR("ca-chatbot-api-response", {
              logLevel: "info",
              message: "Escalating chatbot session API success",
              apiType: "escalateChatbotSession"
            });
            setData(result.message || "Session escalated successfully");
            setError(void 0);
          }).catch((error2) => {
            setError(error2);
            console.error(error2);
            logCustomAttributesNR("ca-chatbot-api-error", {
              errorName: error2.name,
              errorStack: error2.stack,
              message: error2.message,
              logLevel: "error",
              apiType: "escalateChatbotSession"
            });
          }).finally(() => {
            setLoading(false);
            setToggle(false);
          });
        } catch (err) {
          setError(err);
        }
      }
    };
    fetchData();
  }, [toggle]);
  return {
    data,
    loading,
    error,
    trigger
  };
};

export { useCBChatEscalate };
//# sourceMappingURL=src-hooks-chatbot-useCBEscalate.js.map
